import React from "react";

export const ComplianceBanner = () => (
  <div
    data-testid="compliance-banner"
    className="w-full bg-[#0B0B0B] border-b border-[#2A2A2A]"
  >
    <div className="max-w-[1360px] mx-auto px-6 lg:px-10 h-9 flex items-center justify-center gap-3">
      <span className="w-1.5 h-1.5 rounded-full bg-[#1565FF] animate-pulse-slow" />
      <span className="text-[10.5px] tracking-[0.22em] uppercase font-mono text-[#6E7784]">
        Research Use Only · Not For Human Consumption · Certificate of Analysis Available Per Lot
      </span>
    </div>
  </div>
);
